import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import { useCreateUserAddress, useDeleteUserAddresss, useUpdateUserAddress } from "@sdk/react";
import React from "react";
import { useIntl } from "react-intl";
import { AddressForm } from "../AddressForm";
import { Modal } from "../Modal";
export var AddressFormModal = function AddressFormModal(_ref) {
  var hideModal = _ref.hideModal,
      submitBtnText = _ref.submitBtnText,
      cancelBtnText = _ref.cancelBtnText,
      target = _ref.target,
      formImage = _ref.formImage,
      title = _ref.title,
      userId = _ref.userId,
      address = _ref.address,
      formId = _ref.formId,
      props = _objectWithoutProperties(_ref, ["hideModal", "submitBtnText", "cancelBtnText", "target", "formImage", "title", "userId", "address", "formId"]);

  var _React$useState = React.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      show = _React$useState2[0],
      setShow = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      showDeleteModal = _React$useState4[0],
      setDeleteModal = _React$useState4[1];

  var backendValidationErrors = [];
  var intl = useIntl();

  var _useDeleteUserAddress = useDeleteUserAddresss(),
      _useDeleteUserAddress2 = _slicedToArray(_useDeleteUserAddress, 2),
      deleteUserAddress = _useDeleteUserAddress2[0],
      _useDeleteUserAddress3 = _useDeleteUserAddress2[1],
      deleteData = _useDeleteUserAddress3.data,
      addressDeleteErrors = _useDeleteUserAddress3.error;

  var _useCreateUserAddress = useCreateUserAddress(),
      _useCreateUserAddress2 = _slicedToArray(_useCreateUserAddress, 2),
      setCreatUserAddress = _useCreateUserAddress2[0],
      _useCreateUserAddress3 = _useCreateUserAddress2[1],
      createData = _useCreateUserAddress3.data,
      addressCreateErrors = _useCreateUserAddress3.error;

  var _useUpdateUserAddress = useUpdateUserAddress(),
      _useUpdateUserAddress2 = _slicedToArray(_useUpdateUserAddress, 2),
      setUpdateUserAddress = _useUpdateUserAddress2[0],
      _useUpdateUserAddress3 = _useUpdateUserAddress2[1],
      updateData = _useUpdateUserAddress3.data,
      addressUpdateErrors = _useUpdateUserAddress3.error;

  if (addressCreateErrors) {
    backendValidationErrors = addressCreateErrors.extraInfo.userInputErrors;
  }

  if (addressUpdateErrors) {
    backendValidationErrors = addressUpdateErrors.extraInfo.userInputErrors;
  }

  if (addressDeleteErrors) {
    backendValidationErrors = addressDeleteErrors.extraInfo.userInputErrors;
  }

  React.useEffect(function () {
    if (createData && !addressCreateErrors || updateData && !addressUpdateErrors) {
      hideModal();
    }

    if (deleteData && !addressDeleteErrors) {
      setDeleteModal(function (prev) {
        return !prev;
      });
    }
  }, [createData, updateData, deleteData, addressCreateErrors, addressUpdateErrors]);
  return React.createElement(Modal, {
    title: title,
    hide: function hide() {
      hideModal();
      setShow(false);
    },
    formId: formId,
    formImage: formImage,
    disabled: false,
    show: show,
    toDelete: showDeleteModal,
    target: target,
    submitBtnText: submitBtnText,
    cancelBtnText: cancelBtnText
  }, !showDeleteModal ? React.createElement(AddressForm, _extends({}, props, {
    backendValidationErrors: backendValidationErrors,
    formId: formId,
    address: address ? address.address : undefined,
    toDelete: submitBtnText === "Delete",
    handleSubmit: function handleSubmit(data) {
      if (userId) {
        var _data$country;

        setCreatUserAddress({
          input: _objectSpread({}, data, {
            country: data === null || data === void 0 ? void 0 : (_data$country = data.country) === null || _data$country === void 0 ? void 0 : _data$country.code
          })
        });
      } else if (submitBtnText === "Delete") {
        deleteUserAddress({
          addressId: address.id
        });
      } else {
        var _data$country2;

        setUpdateUserAddress({
          id: address.id,
          input: _objectSpread({}, data, {
            country: data === null || data === void 0 ? void 0 : (_data$country2 = data.country) === null || _data$country2 === void 0 ? void 0 : _data$country2.code
          })
        });
      }
    }
  })) : React.createElement("p", null, intl.formatMessage(_defineProperty({
    defaultMessage: " Address had been successfully deleted from your billing addresses list.",
    "id": "@next.components.organisms.AddressFormModal.AddressFormModal.4056837647"
  }, "id", "@next.components.organisms.AddressFormModal.AddressFormModal.4056837647"))));
};